// extracted by mini-css-extract-plugin
export var divider = "_45-0";
export var dividerText = "_45-1";